import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Plans.module.css';
import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator';
import { AuthContext } from '../../Contexts/auth';
import ExecuteAxios from '../../Components/ExecuteAxios/ExecuteAxios';

function Plans() {
    const { clientSelected } = useContext(AuthContext);
    const { authenticated } = useContext(AuthContext);

    const [userCount] = useState(10);
    const [subscriptions, setSubscriptions] = useState({});
    const [loadingSubscriptions, setLoadingSubscriptions] = useState(true);

    const navigate = useNavigate();

    const plans = [
        {
            name: "Basic",
            code: 1,
            pricePerUser: 6,
            description: "Ideal para funcionalidades básicas.",
            features: [
                "IA avançada",
            ],
        },
        {
            name: "Plus",
            code: 2,
            pricePerUser: 8,
            description: "Plano com mais recursos de automação",
            features: [
                "IA avançada",
                "Encaminhamento automático para o síndico",
                "Compartilhamento das novidades automaticamente com os moradores",
            ],
        },
        {
            name: "Premium",
            code: 3,
            pricePerUser: 10,
            description: "Perfeito para condomínios exigentes",
            features: [
                "Benefícios do plano Plus",
                "Integrações com o condomínio",
                "Encaminhamentos das respostas do síndico",
                "Sugestões automáticas para o seu lar",
            ],
        },
    ];

    useEffect(() => {
        const loadSubscriptions = async () => {
            setLoadingSubscriptions(true);

            const result = {};

            for (const plan of plans) {
                result[plan.code] = await getActiveSubscription(plan.code);
            }

            setSubscriptions(result);
            setLoadingSubscriptions(false);
        };

        if (authenticated) {
            loadSubscriptions();
        } else {
            setLoadingSubscriptions(false);
        }
    }, [authenticated, clientSelected]);

    const getActiveSubscription = async (planCode) => {
        if (!authenticated) {
            return false;
        }

        try {
            const response = await ExecuteAxios.api(
                'get',
                '/payment/has-active-subscription/',
                {
                    params: {
                        clientId: clientSelected,
                        planCode
                    }
                }
            );

            return response;
        } catch (error) {
            console.error(error);
            return false;
        }
    };

    const handleSubscribe = (plan) => {
        if (!authenticated) {
            navigate('/login');
            return;
        }

        const subscriptionData = {
            name: plan.name,
            code: plan.code,
            userCount,
            pricePerUser: plan.pricePerUser,
            description: plan.description,
            features: plan.features,
            totalPrice: plan.pricePerUser * userCount,
        };

        localStorage.setItem('selectedPlan', JSON.stringify(subscriptionData));

        navigate('/checkout');
    };


    const handleCancel = async (plan) => {
        try {
            setLoadingSubscriptions(true)
            await ExecuteAxios.api(
                'delete',
                '/payment/cancel-subscription/',
                {
                    params: {
                        clientId: clientSelected,
                    }
                }
            );

            setLoadingSubscriptions(false)

            setSubscriptions((prev) => ({
                ...prev,
                [plan.code]: false
            }));

            alert('Assinatura cancelada com sucesso!');
        } catch (error) {
            console.error(error);
            alert('Erro ao cancelar assinatura.');
        } finally {
            setLoadingSubscriptions(false)
        }
    };

    return (
        <LayoutDefault customMainClass={styles.mainAlternative}>
            <div className={styles.container}>
                <h1 className={styles.titlePlans}>
                    Escolha o plano ideal para o seu condomínio <br />
                    e gerencie mensagens de forma inteligente.
                </h1>

                <div className={styles.cardsWrapper}>
                    {plans.map((plan, index) => (
                        <div
                            key={index}
                            className={
                                plan.name === 'Premium' || plan.name === 'Basic'
                                    ? `${styles.card} ${styles.cardDevelop}`
                                    : styles.card
                            }
                        >
                            {plan.name === 'Premium' && (
                                <div className={styles.tagDevelop}>
                                    Em desenvolvimento
                                </div>
                            )}

                            {plan.name === 'Basic' && (
                                <div className={styles.tagDevelop}>
                                    Inativado
                                </div>
                            )}

                            {plan.name === 'Plus' && (
                                <div className={styles.tag}>
                                    ★ Recomendado
                                </div>
                            )}

                            <h2>
                                Plano <strong>{plan.name}</strong>
                            </h2>

                            <p>{plan.description}</p>

                            <div className={styles.price}>
                                R${(plan.pricePerUser * userCount).toFixed(2)}{' '}
                                <span>/mês</span>
                            </div>

                            <small>
                                R${plan.pricePerUser},00 por usuário
                            </small>

                            <ul>
                                {plan.features.map((feature, i) => (
                                    <li key={i}>{feature}</li>
                                ))}
                            </ul>

                            {plan.name === 'Plus' && !loadingSubscriptions && (
                                subscriptions[plan.code] ? (
                                    <button
                                        className={`${styles.button} ${styles.cancel}`}
                                        onClick={() => handleCancel(plan)}
                                    >
                                        Cancelar
                                    </button>
                                ) : (
                                    <button
                                        className={styles.button}
                                        onClick={() => handleSubscribe(plan)}
                                    >
                                        Assinar plano
                                    </button>
                                )
                            )}

                            {loadingSubscriptions && plan.name === 'Plus' && (
                                <LoadingIndicator loaded={false} />
                            )}

                        </div>
                    ))}
                </div>
            </div>
        </LayoutDefault>
    );
}

export default Plans;